import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

import { axiosFunction } from "../../../../components/commonFunctions/axiosFunction"
import { v2ReactURL } from "../../../../utils/constant";
import AddressComponent from "./AddressComponent";
import { ContactAddressSchema } from "../../../../hooks/ContactRelatedApiZodSchema";
// import { fields } from '../../../../components/common/FormComponent/Contact/FormComponentSchema';

interface AddressDetailsDataProps {
  fetchContactDetails: () => void;
}

const AddressDetailsData: React.FC<AddressDetailsDataProps> = ({  fetchContactDetails }) => {
  const ContactDetails = useSelector((state: any) => state.contactGeneralDetails.ContactDetails);


  const defaultAddressHandler = async (contactAddressId:number) => {
    const res = await axiosFunction(
      `${v2ReactURL}/contact/${ContactDetails.contactId}/updateDefaultAddress/${contactAddressId}`,
      "PUT"
    );
    if (res.data.status) {
      fetchContactDetails();
    }
  };
  // console.log("ContactDetails",fields)
  return (
    <div style={{ margin: "10px", marginBottom: "100px" }}>
      <Grid container item lg={12} spacing={2}>
        {ContactDetails?.contactAddress.map((contact:ContactAddressSchema, index: number) => {
          return (
            <AddressComponent
              key={index}
              contact={contact}
              defaultAddressHandler={defaultAddressHandler}
            />
          );
        })}
      </Grid>
    </div>
  );
};

export default AddressDetailsData;
